import {Component, Input, OnInit} from '@angular/core';
import {Form} from '../../_forms';
import {AlertService} from '../../_services';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {ContactType, PhoneContact} from '../../_models';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
  templateUrl: './phone-contact-fields.component.html',
  selector: 'app-phone-contact-fields'
})
export class PhoneContactFieldsComponent extends Form implements OnInit {
  @Input('phoneContact') phoneContact: PhoneContact = null;
  @Input('phoneTypeOptions') contactTypes: any[] = [];
  public disableTypeSelection: boolean = false;

  constructor(
    protected alertService: AlertService,
    protected router: Router,
    protected location: Location,
    protected formBuilder: FormBuilder
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      id: [null, null],
      contact_type: [null, [Validators.required]],
      phone: [null, [Validators.required]]
    });
    super.ngOnInit();

    this.disableTypeSelection = this.phoneContact && this.phoneContact.contact_type === ContactType.Support || this.contactTypes.length < 2;

    if (this.contactTypes.length === 1) {
      this.phoneContact.contact_type = this.contactTypes[0].id;
    }

    if (this.phoneContact) {
      this.form.patchValue(this.phoneContact);
    }
  }

  getFormData() {
    if (this.form.valid) {
      return this.form.value as PhoneContact;
    }

    return null;
  }
}
